import { render, staticRenderFns } from "./PortfolioListLink.vue?vue&type=template&id=0d03644c&scoped=true&"
import script from "./PortfolioListLink.vue?vue&type=script&lang=js&"
export * from "./PortfolioListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03644c",
  null
  
)

export default component.exports